import { render, staticRenderFns } from "./shipping-information.vue?vue&type=template&id=78656211&"
import script from "./shipping-information.vue?vue&type=script&lang=js&"
export * from "./shipping-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports